import { API_ENDPOINT, AUTH_HEADERS } from "../../util/constants";
import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { handleUnauthorizedAccess } from "../../util/utility";

export function updateBroadcasterStatus(token, api_token, status) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/updateStatus?api_token=${api_token}&status=${status}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.UPDATE_BROADCASTER_REQUEST, types.UPDATE_BROADCASTER_RECEIVE, {
                type: types.UPDATE_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function createBroadcast(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcast?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CREATE_BROADCAST_REQUEST, types.CREATE_BROADCAST_RECEIVE, {
                type: types.CREATE_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCreateBroadcast = () => ({
    type: types.RESET_CREATE_BROADCAST,
    payload: null
});

export function createAvailability(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/availability?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CREATE_AVAILABILITY_REQUEST, types.CREATE_AVAILABILITY_RECEIVE, {
                type: types.CREATE_AVAILABILITY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function updateAvailability(token, api_token, data, availabilityId) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/availability/${availabilityId}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CREATE_AVAILABILITY_REQUEST, types.CREATE_AVAILABILITY_RECEIVE, {
                type: types.CREATE_AVAILABILITY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function closeAvailability(token, api_token, availabilityId) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/availability/${availabilityId}?api_token=${api_token}`,
            method: 'DELETE',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.CREATE_AVAILABILITY_REQUEST, types.CREATE_AVAILABILITY_RECEIVE, {
                type: types.CREATE_AVAILABILITY_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetAvailability = () => ({
    type: types.RESET_AVAILABILITY_BROADCAST,
    payload: null
});


export function createPrivateBroadcast(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/private-session?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CREATE_PRIVATE_BROADCAST_REQUEST, types.CREATE_PRIVATE_BROADCAST_RECEIVE, {
                type: types.CREATE_PRIVATE_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPrivateBroadcast = () => ({
    type: types.RESET_CREATE_PRIVATE_BROADCAST,
    payload: null
});